import React, { FC } from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { isWeb } from '@helpers';
import { useTourContext } from './TourProvider';
import Svg from '@styles/icons/svg';
import ColorsWrapper from '@styles/colors';
import type { TourTriggerComponentProps } from '@components/tours/types';

const TourTriggerComponent: FC<TourTriggerComponentProps> = ({ tourId, children, C }) => {
  const { startTour, isActive } = useTourContext();

  if (!isWeb) {
    return null;
  }

  const handlePress = () => {
    if (!isActive) {
      startTour(tourId);
    }
  };

  if (children) {
    return (
      <TouchableOpacity onPress={handlePress} disabled={isActive}>
        {children}
      </TouchableOpacity>
    );
  }

  return (
    <TouchableOpacity onPress={handlePress} disabled={isActive} style={styles.defaultTrigger}>
      <Svg icon="questionMark" width={20} height={20} color={C('Label/Light/Secondary')} />
      <Text style={[styles.triggerText, { color: C('Label/Light/Secondary') }]}>Help</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  defaultTrigger: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    padding: 8,
  },
  triggerText: {
    fontSize: 14,
  },
});

export const TourTrigger = ColorsWrapper(TourTriggerComponent);
export default TourTrigger;
